import { render, staticRenderFns } from "./EmailTemplatesList.vue?vue&type=template&id=c9557bda&scoped=true"
import script from "./EmailTemplatesList.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplatesList.vue?vue&type=style&index=0&id=c9557bda&prod&scoped=true&lang=scss"
import style1 from "./EmailTemplatesList.vue?vue&type=style&index=1&id=c9557bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9557bda",
  null
  
)

export default component.exports